import script from "./CookieConsent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&setup=true&lang=ts"

import "./CookieConsent.vue?vue&type=style&index=0&id=7e7c2a08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7c2a08"]])

export default __exports__